import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import md5 from 'blueimp-md5'
import clsx from 'clsx'
import copyToClipboard from 'copy-to-clipboard'
import ChipInput from 'material-ui-chip-input'
import React, { useContext, useEffect, useState } from 'react'

import { addOrEditOffer, getOffersList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import ImageUploadToS3 from '../../services/ImageUpload'
import history from '../../services/history'

function OfferingPage() {
  const classes = useStyles()
  const { setUser, setAboutCurrentPage, setShowLoadingModal } = useContext(Context)
  const [data, setData] = useState(null)
  const [crudData, setCrudData] = useState(null)
  const [actionIntent, setActionIntent] = useState(null)
  const [itemImage, setItemImage] = useState(null)
  const [loadingModalRequest, setLoadingModalRequest] = useState(false)

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
      getItems()
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Campanhas de vendas'
    })
  }, [])

  async function getItems() {
    const data = await getOffersList()
    if (data.message) return setData(false)

    setData(data.sort(one => (one.isDefault ? -1 : 1)))
  }

  function showCrudModal(item) {
    setCrudData(item || {})
  }

  function updateCrudData(prop, value) {
    setCrudData(crudData => ({
      ...crudData,
      [prop]: value
    }))
  }

  function showItemImage(item) {
    setItemImage(item)
  }

  function activateItem(item) {
    setActionIntent({
      item,
      action: 'activate'
    })
  }

  function deactivateItem(item) {
    setActionIntent({
      item,
      action: 'deactivate'
    })
  }

  function deleteItem(item) {
    setActionIntent({
      item,
      action: 'delete'
    })
  }

  function setItemAsDefault(item) {
    setActionIntent({
      item,
      action: 'setAsDefault'
    })
  }

  function hideCrudModal() {
    if (loadingModalRequest) return
    setCrudData(null)
  }

  function hideActionIntentModal() {
    if (loadingModalRequest) return
    setActionIntent(null)
  }

  function hideItemImageModal() {
    if (loadingModalRequest) return
    setItemImage(null)
  }

  function cancelIntent() {
    setActionIntent(null)
  }

  async function executeIntent() {
    setLoadingModalRequest(true)
    setShowLoadingModal(true)
    const overwriting = {
      activate: { situation: 1 },
      delete: { situation: 2 },
      deactivate: { situation: 3 },
      setAsDefault: { isDefault: true }
    }[actionIntent.action]
    await addOrEditOffer({
      ...actionIntent.item,
      ...overwriting
    })
    setLoadingModalRequest(false)
    setShowLoadingModal(false)
    setData(null)
    setActionIntent(null)
    getItems()
  }

  async function saveItem() {
    setLoadingModalRequest(true)
    setShowLoadingModal(true)
    const finalData = { ...crudData }
    if (finalData.image instanceof File) {
      const path = await ImageUploadToS3(finalData.image, 'images/offers/')
      finalData.image = process.env.REACT_APP_IMAGES_URL + path
    }

    if (finalData.desktopImage instanceof File) {
      const path = await ImageUploadToS3(finalData.desktopImage, 'images/offers/')
      finalData.desktopImage = process.env.REACT_APP_IMAGES_URL + path
    }

    await addOrEditOffer(finalData)
    setLoadingModalRequest(false)
    setShowLoadingModal(false)
    setData(null)
    setCrudData(null)
    getItems()
  }

  function transformNumberIntoPrice(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: 'symbol'
    }).format(typeof value === 'number' ? value : Number((value || ''.replace(/\D/g, '')) / 100))
  }

  function transformStringIntoNumber(value) {
    return Number((value || '').replace(/\D/g, '')) / 100
  }

  async function handleImageChange(e) {
    setCrudData(crudData => ({
      ...crudData,
      image: e.target.files[0]
    }))
  }

  async function handleDesktopImage(e) {
    setCrudData(crudData => ({
      ...crudData,
      desktopImage: e.target.files[0]
    }))
  }

  return (
    <>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container style={{ marginBottom: '25px', marginTop: '15px' }}>
              <Grid className={classes.row} item xs={12}>
                <Typography variant="h4">Ofertas</Typography>
                <Button size="large" variant="contained" color="primary" onClick={showCrudModal}>
                  Adicionar
                </Button>
              </Grid>
              <Grid item xs={12}>
                {data === null && <Typography variant="body1">Carregando...</Typography>}
                {data === false && <Typography variant="body1">Houve algum erro.</Typography>}
                {data &&
                  data.map(item => (
                    <Card
                      className={clsx(classes.card, item.isDefault && classes.defaultItem)}
                      key={item.id}
                      elevation={item.isDefault ? 3 : 1}
                    >
                      <CardHeader
                        title={
                          <>
                            {item.title} ({item.offerLogan || '---'}) &nbsp;&nbsp;&nbsp;
                            {!!item.offerLogan && (
                              <Button
                                color="secondary"
                                variant="contained"
                                size="small"
                                onClick={() =>
                                  copyToClipboard(
                                    `https://clube.gazetadopovo.com.br/assine/?offerId=${md5(
                                      item.id
                                    )}`
                                  )
                                }
                              >
                                Copiar link
                              </Button>
                            )}
                          </>
                        }
                        subheader={item.isDefault ? 'Oferta padrão' : null}
                      />
                      <CardContent>
                        <Typography variant="subtitle1">
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                            currencyDisplay: 'symbol'
                          }).format(item.price)}{' '}
                          &bull; {item.priceDescription}
                        </Typography>
                        <Typography variant="subtitle2">{item.offerDescription}</Typography>
                        <Typography variant="body2">
                          {
                            {
                              1: 'Mensal',
                              2: 'Anual',
                              3: 'Sem período'
                            }[item.typePlan]
                          }{' '}
                          &bull;{' '}
                          {
                            {
                              1: 'Ativo',
                              2: 'Excluído',
                              3: 'Rascunho'
                            }[item.situation]
                          }
                        </Typography>
                      </CardContent>
                      <CardActions>
                        {item.image && (
                          <Button color="primary" size="small" onClick={() => showItemImage(item)}>
                            Ver imagem
                          </Button>
                        )}
                        <Button color="primary" size="small" onClick={() => showCrudModal(item)}>
                          Editar
                        </Button>
                        {item.situation !== 1 ? (
                          <Button color="primary" size="small" onClick={() => activateItem(item)}>
                            Ativar
                          </Button>
                        ) : null}
                        {!item.isDefault ? (
                          <>
                            {item.situation === 1 ? (
                              <Button
                                color="primary"
                                size="small"
                                onClick={() => deactivateItem(item)}
                              >
                                Desativar
                              </Button>
                            ) : null}
                            <Button color="primary" size="small" onClick={() => deleteItem(item)}>
                              Excluir
                            </Button>
                            <Button
                              color="primary"
                              size="small"
                              onClick={() => setItemAsDefault(item)}
                            >
                              Definir como padrão
                            </Button>
                          </>
                        ) : null}
                      </CardActions>
                    </Card>
                  ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      {/* add/edit modal */}
      <Dialog
        open={!!crudData}
        maxWidth="lg"
        scroll="body"
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>
          {loadingModalRequest ? (
            <>
              <CircularProgress color="primary" size={18} />
              &nbsp;&nbsp;&nbsp;
            </>
          ) : null}
          {crudData?.id ? 'Editar' : 'Adicionar'} oferta
        </DialogTitle>
        <DialogContent className={classes.column}>
          <RadioGroup
            value={String(crudData?.typePlan)}
            onChange={e => updateCrudData('typePlan', Number(e.target.value))}
          >
            <FormControlLabel value="1" label="Mensal" control={<Radio color="primary" />} />
            <FormControlLabel value="2" label="Anual" control={<Radio color="primary" />} />
            <FormControlLabel value="3" label="Sem período" control={<Radio color="primary" />} />
          </RadioGroup>
          {[
            { label: 'Título', prop: 'title' },
            { label: 'ID da oferta', prop: 'offerLogan' },
            {
              label: 'Descrição da oferta',
              prop: 'offerDescription',
              lines: 6
            },
            {
              label: 'Preço',
              prop: 'price',
              transformValue: transformNumberIntoPrice,
              transformOnChange: transformStringIntoNumber
            },
            { label: 'Descrição do preço', prop: 'priceDescription', lines: 4 }
          ].map(field => (
            <TextField
              key={field.prop}
              className={classes.textField}
              label={field.label}
              variant="outlined"
              multiline={field?.lines > 1}
              rows={field?.lines || 1}
              value={(value => (field.transformValue ? field.transformValue(value) : value) || '')(
                (crudData || {})[field.prop]
              )}
              onChange={e =>
                updateCrudData(
                  field.prop,
                  field.transformOnChange ? field.transformOnChange(e.target.value) : e.target.value
                )
              }
            />
          ))}
          <ChipInput
            className={classes.textField}
            label="Benefícios"
            variant="outlined"
            value={crudData?.benefits?.split('\n') || []}
            onAdd={chip =>
              updateCrudData(
                'benefits',
                [...(crudData?.benefits?.split('\n') || []), chip].join('\n')
              )
            }
            onDelete={(_, index) =>
              updateCrudData(
                'benefits',
                [
                  ...(crudData?.benefits?.split('\n') || []).slice(0, index),
                  ...(crudData?.benefits?.split('\n') || []).slice(index + 1)
                ].join('\n')
              )
            }
          />
          {crudData?.image ? (
            <img
              className={classes.itemImage}
              src={(image => (image instanceof File ? URL.createObjectURL(image) : image))(
                crudData.image
              )}
            />
          ) : null}
          <label className={classes.alignStart}>
            <Button color="primary" component="span">
              Upload de imagem mobile
            </Button>
            <input
              className={classes.hidden}
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
          </label>
          {crudData?.desktopImage ? (
            <img
              className={classes.itemImage}
              src={(image => (image instanceof File ? URL.createObjectURL(image) : image))(
                crudData.desktopImage
              )}
            />
          ) : null}
          <label className={classes.alignStart}>
            <Button color="primary" component="span">
              Upload de imagem para Desktop
            </Button>
            <input
              className={classes.hidden}
              type="file"
              accept="image/*"
              onChange={handleDesktopImage}
            />
          </label>
        </DialogContent>
        <DialogActions>
          <Button onClick={hideCrudModal}>Cancelar</Button>
          <Button
            color="primary"
            onClick={saveItem}
            disabled={['typePlan', 'title', 'offerLogan', 'offerDescription'].some(
              field => !(crudData || {})[field]
            )}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
      {/* activate/deactivate/exclude/set-as-default modal */}
      <Dialog
        open={!!actionIntent}
        onClose={hideActionIntentModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>
          {loadingModalRequest ? (
            <>
              <CircularProgress color="primary" size={18} />
              &nbsp;&nbsp;&nbsp;
            </>
          ) : null}
          {
            {
              delete: 'Excluir oferta',
              deactivate: 'Desativar oferta',
              activate: 'Ativar oferta',
              setAsDefault: 'Definir oferta como padrão'
            }[actionIntent?.action]
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente{' '}
            {
              {
                delete: 'excluir',
                deactivate: 'desativar',
                activate: 'ativar',
                setAsDefault: 'tornar padrão'
              }[actionIntent?.action]
            }{' '}
            a oferta {actionIntent?.item?.title}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={cancelIntent}>
            Não
          </Button>
          <Button color="primary" onClick={executeIntent}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
      {/* image modal */}
      <Dialog
        open={!!itemImage}
        maxWidth="lg"
        onClose={hideItemImageModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Imagem de {itemImage?.title}</DialogTitle>
        <DialogContent>
          {itemImage?.image && (
            <>
              <DialogContentText>Mobile</DialogContentText>
              <img className={classes.itemImage} src={itemImage?.image} />
            </>
          )}
          {itemImage?.desktopImage && (
            <>
              <DialogContentText>Desktop</DialogContentText>
              <img className={classes.itemImage} src={itemImage?.desktopImage} />
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  column: {
    display: 'grid',
    gridTemplateColumns: '100%',
    width: '450px',
    gap: '20px'
  },
  card: {
    margin: '20px 0'
  },
  defaultItem: {
    borderLeft: '6px solid #3f51b5'
  },
  textField: {
    width: '100%'
  },
  itemImage: {
    width: '100%',
    height: 'auto'
  },
  hidden: {
    opacity: 0,
    visibility: 'hidden',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  alignStart: {
    justifySelf: 'start'
  }
})

export default OfferingPage
